<footer class="footer">
  <div class="footer-content">
    <span>&copy; {{ year }} · Powered by Torosanto</span>
    <span class="version">v1.0.0</span>
  </div>
</footer>
